import { Button } from "@mui/material";

export default function CommentButtons({ handleSave, handleCancel, isDisable }) {
  return (
    <div className="text-editor-btn-div">
      <Button
        onClick={handleSave}
        className="theme-bg-color text-editor-btn1"
        variant="contained"
        disabled={isDisable}>
        <div className="text-editor-btn-content">Save</div>
      </Button>
      <Button
        onClick={handleCancel}
        className="text-editor-btn2"
        variant="outlined">
        <div className="text-editor-btn-content">Cancel</div>
      </Button>
    </div>
  );
}
